import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import api from '../lib/api'
import { getToken, setToken, getAdmin, setAdmin, clearAuth } from '../lib/auth'

export const useAuthStore = defineStore('auth', () => {
  const token = ref(getToken())
  const admin = ref(getAdmin())

  const isAuthenticated = computed(() => !!token.value)
  const adminName = computed(() => admin.value?.name || '')

  async function login(email, password) {
    const response = await api.post('/auth/login', { email, password })
    token.value = response.data.token
    admin.value = response.data.admin
    setToken(response.data.token)
    setAdmin(response.data.admin)
    return response.data
  }

  function logout() {
    token.value = null
    admin.value = null
    clearAuth()
  }

  return { token, admin, isAuthenticated, adminName, login, logout }
})
